import { useState } from "react"

import { Badge } from "@minuthq/meatball-ui-react"
import { Button } from "@minuthq/meatball-ui-react"

import { ParadiseLLMPromptsTable } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptsTable"
import { useParadiseLLMPromptsFilter } from "src/components/Paradise/ParadiseLLMPrompts/useParadiseLLMPromptsFilter"
import {
  ParadiseLayout,
  ParadiseTitle,
} from "src/components/Paradise/sharedStyles"
import { useFetchParadiseLLMPrompts } from "src/data/paradise/paradiseLLMPrompts/queries/paradiseLLMPromptsQueries"
import { Titlebar } from "src/ui/Layout/Titlebar"
import { spacing } from "src/ui/spacing"

import { ParadiseCreateLLMPromptDialog } from "./ParadiseCreateLLMPromptDialog"

const LIMIT = 50

export function ParadiseLLMPrompts() {
  const { filter, setFilter, offset, setOffset, sortedFilters } =
    useParadiseLLMPromptsFilter()

  const fetchedPrompts = useFetchParadiseLLMPrompts({
    filter: {
      limit: LIMIT,
      offset,
      category: filter.llm_prompts_category || undefined,
      created_by_user_id: filter.llm_prompts_created_by_user_id || undefined,
    },
    options: {
      keepPreviousData: true,
    },
  })

  const [createDialogOpen, setCreateDialogOpen] = useState(false)

  return (
    <ParadiseLayout>
      <Titlebar
        bottomMargin={spacing.S}
        title={
          <ParadiseTitle>
            LLM Prompts
            {fetchedPrompts.isSuccess && (
              <>
                <Badge color="good">
                  Total: {fetchedPrompts.data?.paging.total_count}
                </Badge>
              </>
            )}
          </ParadiseTitle>
        }
        actionBar={
          <Button
            variant="primary"
            onClick={() => setCreateDialogOpen(true)}
            style={{ marginBottom: 24 }}
          >
            Create Prompt
          </Button>
        }
        size="unset"
      />

      <ParadiseLLMPromptsTable
        sortedFilters={sortedFilters}
        prompts={fetchedPrompts.data?.prompts ?? []}
        offset={offset}
        limit={LIMIT}
        setOffset={setOffset}
        filter={filter}
        setFilter={setFilter}
        totalCount={fetchedPrompts.data?.paging.total_count}
        isLoading={fetchedPrompts.isLoading}
        isLoadingMore={fetchedPrompts.isPreviousData}
        error={{
          hasError: fetchedPrompts.isError,
          title: fetchedPrompts.error?.message,
        }}
      />

      {createDialogOpen && (
        <ParadiseCreateLLMPromptDialog
          onClose={() => setCreateDialogOpen(false)}
        />
      )}
    </ParadiseLayout>
  )
}
